
import { useEffect } from 'react';
import { useFormContext } from "react-hook-form";

export const useRepatCalculations = (basePath: string) => {
  const { setValue, watch } = useFormContext();

  // Watch values for room counts
  const singles = watch(`${basePath}.singles`, '5');
  const doubles = watch(`${basePath}.doubles`, '15');
  const triples = watch(`${basePath}.triples`, '8');
  const quadruples = watch(`${basePath}.quadruples`, '4');
  const quintuples = watch(`${basePath}.quintuples`, '2');
  const otherSpaces = watch(`${basePath}.otherSpaces`, '0');
  const additionalBeds = watch(`${basePath}.additionalBeds`, '5');
  
  // Watch totals
  const totalRooms = watch(`${basePath}.totalRooms`, '34');
  const totalCapacity = watch(`${basePath}.totalCapacity`, '73');

  // Calculate totals
  useEffect(() => {
    const singlesCount = parseInt(singles) || 0;
    const doublesCount = parseInt(doubles) || 0;
    const triplesCount = parseInt(triples) || 0;
    const quadruplesCount = parseInt(quadruples) || 0;
    const quintuplesCount = parseInt(quintuples) || 0;
    const otherSpacesCount = parseInt(otherSpaces) || 0;
    const additionalBedsCount = parseInt(additionalBeds) || 0;

    const totalRoomsCalc = 
      singlesCount + 
      doublesCount + 
      triplesCount + 
      quadruplesCount + 
      quintuplesCount;

    const totalCapacityCalc = 
      singlesCount * 1 + 
      doublesCount * 2 + 
      triplesCount * 3 + 
      quadruplesCount * 4 + 
      quintuplesCount * 5 + 
      otherSpacesCount + 
      additionalBedsCount;

    setValue(`${basePath}.totalRooms`, totalRoomsCalc.toString());
    setValue(`${basePath}.totalCapacity`, totalCapacityCalc.toString());
  }, [singles, doubles, triples, quadruples, quintuples, otherSpaces, additionalBeds, setValue, basePath]);

  return {
    singles,
    doubles,
    triples,
    quadruples,
    quintuples,
    otherSpaces,
    additionalBeds,
    totalRooms,
    totalCapacity
  };
};
